<template>
	<div class="background" :class="color">
		<!-- <svg v-if="rotating" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1080" height="1080" viewBox="0 0 1080 1080">
			<defs>
				<clipPath id="clip-path">
				<rect x="420" width="1080" height="1080" fill="none"/>
				</clipPath>
				<clipPath id="clip-path-2">
				<rect id="Rettangolo_69" data-name="Rettangolo 69" width="1920" height="1080" fill="#fff"/>
				</clipPath>
			</defs>
			<g id="Raggruppa_240" data-name="Raggruppa 240" transform="translate(-6149 645)">
				<g id="Scorri_gruppo_1" data-name="Scorri gruppo 1" transform="translate(5729 -645)" clip-path="url(#clip-path)" style="isolation: isolate">
				<g id="Gruppo_di_maschere_5" data-name="Gruppo di maschere 5" clip-path="url(#clip-path-2)">
					<g id="Raggruppa_178" data-name="Raggruppa 178" transform="translate(-164.315 -592.399)" opacity="0.4">
					<path id="Tracciato_152" data-name="Tracciato 152" d="M2433.239,0l199.913,1131.557L2833.042,0Z" transform="translate(-1508.826 0)" fill="#fff"/>
					<path id="Tracciato_153" data-name="Tracciato 153" d="M3517.489,343.123l-558.045,998.245,864.313-735.415Z" transform="translate(-1835.12 -209.804)" fill="#fff"/>
					<path id="Tracciato_154" data-name="Tracciato 154" d="M2959.426,2286.235l1124.313,4.835-69.425-402.679Z" transform="translate(-1835.108 -1154.666)" fill="#fff"/>
					<path id="Tracciato_155" data-name="Tracciato 155" d="M4017.543,3301.033,2959.406,2912.319l858.235,742.824Z" transform="translate(-1835.096 -1780.751)" fill="#fff"/>
					<path id="Tracciato_156" data-name="Tracciato 156" d="M3149.972,4045.54l375.693-139.849L2959.393,2912.3Z" transform="translate(-1835.088 -1780.743)" fill="#fff"/>
					<path id="Tracciato_157" data-name="Tracciato 157" d="M1468.908,3905.679,1844.6,4045.528l190.558-1133.246Z" transform="translate(-910.854 -1780.729)" fill="#fff"/>
					<path id="Tracciato_158" data-name="Tracciato 158" d="M374.111,3655.11l858.224-742.844L174.209,3301Z" transform="translate(-108.025 -1780.719)" fill="#fff"/>
					<path id="Tracciato_159" data-name="Tracciato 159" d="M0,2291.069l1124.317-4.858L69.425,1888.39Z" transform="translate(0 -1154.665)" fill="#fff"/>
					<path id="Tracciato_160" data-name="Tracciato 160" d="M684.355,605.953l864.33,735.4L990.623,343.123Z" transform="translate(-424.361 -209.804)" fill="#fff"/>
					</g>
				</g>
				</g>
			</g>
		</svg> -->
	</div>
</template>

<script>
export default {
	props: ['color','rotating'],
}
</script>
<style scoped lang="scss">
	.background {
		transition: all 0.3s;
		z-index: 0;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-image: url('../assets/pattern.svg');
		background-repeat: repeat;
		background-position: 0 0;
		background-attachment: scroll;
		/* animation: animatedBackground 500s linear infinite; */
		background-size: max(15vw,200px);
		transform-origin: center;
		svg {
			transform: translateY(-100%) translateX(-100%);
			position: fixed;
			left: -100%;
			top: -100%;
			width: 300%;
			height: 300%;
			/* animation: rotatingBackground 10s linear infinite; */
		}
	}
	@keyframes rotatingBackground {
		from {
			transform: rotate(0);
		}
		to {
			transform: rotate(360deg) ;
		}
	}
	@keyframes animatedBackground {
		from {
			background-position: 0 0;
		}
		to {
			background-position: px(-10000) px(-10000);
		}
	}
</style>